(function () {
  'use strict';

  function bind() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach(function(form) {
      const btn = form.querySelector('[data-pc-start-custom="1"]');
      if (!btn) return;

      if (form.dataset.pcBound === '1') return;
      form.dataset.pcBound = '1';

      function run(e) {
        if (form.dataset.pcBusy === '1') return;
        form.dataset.pcBusy = '1';

        e.preventDefault();
        e.stopPropagation();

        const variantInput = form.querySelector('input[name="id"]');
        const variantId = variantInput ? variantInput.value : null;
        if (!variantId) {
          alert('Please select a product option.');
          form.dataset.pcBusy = '0';
          return;
        }

        // 从按钮的 data-product-id 属性获取数字 productId
        const productId = btn.dataset.productId || null;
        
        console.log('👉 [调试] 最终发送给弹窗的 ProductID:', productId);

        const sessionId = 'pc_' + Date.now() + '_' + Math.random().toString(16).slice(2);
        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantity = qtyInput ? qtyInput.value : 1;

        if (typeof window.openCustomDrawer === 'function') {
          window.openCustomDrawer(variantId, productId, sessionId, quantity);
        } else {
          console.error('Custom Drawer function not found.');
        }
        
        setTimeout(() => { form.dataset.pcBusy = '0'; }, 500);
      }

      btn.addEventListener('click', run, true);
      form.addEventListener('submit', function(e) { run(e); }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();